//=include _jquery.elevateZoom-3.0.8.min.js

$(document).ready(function() {
	$('.zoom').elevateZoom({
		zoomType			: $('body').hasClass('mode_mobile') ? 'inner' : 'window',
		zoomWindowPosition	: 1,
		zoomWindowWidth		: 585,
		zoomWindowHeight	: 585,
		zoomWindowOffetx	: 10,
		borderSize			: 1,
		cursor				: $('body').hasClass('mode_mobile') ? 'crosshair' : 'pointer',
		easing				: true,
		gallery				: 'produit_thumbs',
		galleryActiveClass	: 'active'
	});

	$('body').on('click', function(e) {
		if ($('.contact_vendeur_popup').is(':visible') && !$('.contact_vendeur_popup').is(':hover')) {
			$('.contact_vendeur_popup').hide();
		}
	});

	$('.trigger_contact_vendeur_popup').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();

		$('.contact_vendeur_popup').toggle();
	});

	$('.onglet').on('click', function(e) {
		e.preventDefault();

		if (!$(this).hasClass('active')) {
			$('.onglet').removeClass('active');
			$(this).addClass('active');
			$('.onglet_content').hide();
			$($(this).attr('href')).show();
		}
	});
	$('.onglet').first().trigger('click');

	resize_photos();
	function resize_photos() {
		$('.produit_illustration').height($('.produit_illustration').width());
		$('.produit_illustration img').css({'max-height' : $('.produit_illustration').width()});
		$('.produit_thumb').height($('.produit_thumb').width());
		$('.produit_thumb img').css({'max-height' : $('.produit_thumb').width()});
	}
	$('.produit_illustration, .produit_thumb').resize(debounce(resize_photos, 100));
});
